import { loadFromStorage, saveToStorage } from '../../Utils/storage'

export const shownToast = (state, setProgress) => {
  setProgress(progressReducer(state, { showToast: false }))
}

export const progressReducer = (state, delta) => {
  if (!delta) {
    return state
  }

  // Copy delta
  const newState = { ...state }
  Object.assign(newState, delta)

  // If only updating toast state, return new state
  if (Object.keys(delta).length === 1 && 'showToast' in delta) {
    return newState
  }

  // Compute derived metrics
  newState.total =
    newState.numAccepted +
    newState.numAuditReady +
    newState.numReadyForReview +
    newState.numNeedsAttention
  if (newState.total > 0) {
    newState.percentComplete = Math.round(
      ((newState.total - newState.numNeedsAttention) / newState.total) * 100,
    )
  }

  // load previous toast percentage
  const lastToast = loadFromStorage('lastToast', { percent: -1 })

  if (lastToast.percent >= 0) {
    // toast if there's been at least 5% progress since last toast
    newState.showToast =
      newState.percentComplete - lastToast.percent > 1 &&
      newState.percentComplete > lastToast.percent + 5
  }

  // save toast percentage
  if (newState.showToast || lastToast.percent < 0) {
    saveToStorage('lastToast', { percent: newState.percentComplete })
  }

  return newState
}
